import { useContext } from 'react';
import { RTLSupportContext } from './context';

export const useRTLSupportContext = () => useContext(RTLSupportContext);

export const useIsRTL = () => useRTLSupportContext().isRTL;
